// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jgdY","title":"styles_title__3F9t0"};